import { Injectable } from '@angular/core';
import { type Observable, of } from 'rxjs';
import { FilterConfigService, type FilterDataResult, SearchFilterModel } from '@ui/shared/util-filter';
import type { SportMapFilterKey } from '../../types/sport-map-filter';

@Injectable({ providedIn: 'root' })
export class SearchFilterConfigService extends FilterConfigService<SportMapFilterKey, undefined> {
    public override placeholder = 'Name des Vereins oder der Sportstätte';

    constructor() {
        super(
            new SearchFilterModel('search', 'Suchbegriff', []),
            undefined,
        );
    }

    protected _getOptions$(): Observable<FilterDataResult> {
        return of({ data: [] });
    }
}
